export interface Item {
  id: string;
  name: string;
  category: string;
  checked: boolean;
  category_id: string;
  description: string;
  images: ItemImage[];
}

export interface ItemImage {
  id: string;
  url: string;
}

export interface Category {
  id: string;
  name: string;
  items: Array<Item>;
}

export type Reorderable = Category | Item;

export function isCategory(listItem: Reorderable): listItem is Category {
  return (listItem as Category).items !== undefined;
}

export interface Authorization {
  can_view_checklist: boolean;
  can_edit_checklist: boolean;
  can_destroy_checklist: boolean;
  can_share_checklist: boolean;
  can_create_item: boolean;
  can_edit_item: boolean;
  can_destroy_item: boolean;
  can_edit_category: boolean;
  can_destroy_category: boolean;
}

export type ChangeBase = {
  id: string;
  author_username: string;
  created_at: number;
  checklist_id: string;
  suggestion_id?: string;
  synced_to_server: boolean;
};

export type DeleteCategoryChange = {
  name: "deleteCategory";
  payload: {
    categoryName: string;
  };
};

export type DeleteItemChange = {
  name: "deleteItem";
  payload: {
    itemId: string;
    itemName: string;
    categoryName: string;
  };
};
export type RenameCategoryChange = {
  name: "renameCategory";
  payload: {
    oldCategoryName: string;
    newCategoryName: string;
  };
};

export type MoveItemChange = {
  name: "moveItem";
  payload: {
    itemId: string;
    itemName: string;
    oldCategoryName: string;
    newCategoryName: string;
    oldItemPosition: number;
    newItemPosition: number;
  };
};

export type MoveCategoryChange = {
  name: "moveCategory";
  payload: {
    categoryName: string;
    oldPosition: number;
    newPosition: number;
  };
};

export type CreateItemChange = {
  name: "createItem";
  payload: {
    itemId: string;
    itemName: string;
    categoryName: string;
    description: string;
    images: ItemImage[];
  };
};

export type CheckUncheckItemChange = {
  name: "checkUncheckItem";
  payload: {
    itemId: string;
    itemName: string;
    checked: boolean;
  };
};

export type UpdateItemChangePayload = {
  itemId: string;
  name: string;
  newName?: string;
  category?: {
    old: string;
    new: string;
  };
  description?: {
    old: string;
    new: string;
  };
  images: ItemImage[];
};
export type UpdateItemChange = {
  name: "updateItem";
  payload: UpdateItemChangePayload;
};

export type PartialChange =
  | DeleteCategoryChange
  | DeleteItemChange
  | RenameCategoryChange
  | MoveItemChange
  | MoveCategoryChange
  | CreateItemChange
  | CheckUncheckItemChange
  | UpdateItemChange;

export type Change = ChangeBase & PartialChange;

export interface Checklist {
  id: string;
  is_template: boolean;
  categories: Array<Category>;
  authorization: Authorization;
  changes: Array<Change>;
  newest_synced_change_created_at: number | null;
}

export interface CurrentUser {
  id: string;
  username: string;
}

export interface Suggestion {
  suggestionId?: string;
  isSuggestionMode: boolean;
}

export interface ItemForm {
  isNewItemMode: boolean;
  isEditItemMode: boolean;
  itemToEditId: string | null;
}

export type ExpandedImages = Record<string, File | null>;
